import moment from "moment";

// Define greenlandic for moment with locale code "kl".
if (moment.locales().filter(x => x === "kl").length < 1) {
    const currentLang = moment.locale();
    moment.defineLocale("kl", {
        parentLocale: "da",
        months: "Januaari_Februaari_Marsi_Apriili_Maaji_Juuni_Juuli_Aggusti_Septembari_Oktobari_Novembari_Decembari".split("_"),
        monthsShort: "Jan_Feb_Mar_Apr_Maj_Jun_Jul_Aug_Sep_Okt_Nov_Dec".split("_"),
        weekdays: "Sapaat_Ataasinngorneq_Marlunngorneq_Pingasunngorneq_Sisamanngorneq_Tallimanngorneq_Arfininngorneq".split("_"),
        weekdaysShort: "Sap_Ataa_Mar_Ping_Sis_Tall_Arf".split("_"),
        weekdaysMin: "Sap_Ataa_Mar_Ping_Sis_Tall_Arf".split("_")
    });
    moment.locale(currentLang);
}
